import {
    createAsyncThunk,
    createEntityAdapter,
    createSelector,
    createSlice,
} from "@reduxjs/toolkit";
import sharedComponent from '../../biz/sharedBiz';

const initialState = {
    countryStates: [],
}

export const fetchStates = createAsyncThunk('stateArea/fetchStates', async () => {
    const result = await sharedComponent.getAreas();
    return result;
})

const stateAreaSlice = createSlice({
    name: 'stateArea',
    initialState,
    reducers: {},
    extraReducers(builder) {
        builder
            .addCase(fetchStates.fulfilled, (state, action) => {
                state.countryStates = action.payload
            })
    }
})

export default stateAreaSlice.reducer;